import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { radioIconStyles as styles } from './RadioIcon.style'

function RadioIconBase() {
  return <Box sx={styles.radioIcon} />
}

function RadioCheckedIconBase() {
  return <Box sx={[styles.radioIcon, styles.radioCheckedIcon] as SxProps} />
}

const MemoRadioIcon = memo(RadioIconBase)
const MemoRadioCheckedIcon = memo(RadioCheckedIconBase)
export { MemoRadioIcon as RadioIcon, MemoRadioCheckedIcon as RadioCheckedIcon }
